/**
 * Cliente API de avisos.
 *
 * Vista vecino (Sprint 12 S12-09): GET /vecino/avisos/ retorna avisos
 * vigentes (vigente_hasta NULL o >= now).
 *
 * Vista comision (Sprint 13 S13-06, migrado desde frontend-superadmin):
 * listar admin, crear con fan-out sincrono a vecinos activos, retirar
 * (PATCH vigente_hasta).
 */
import { apiFetch } from './client';
import type {
  AvisoCreate,
  AvisoCreadoResponse,
  AvisoRead,
  TipoAviso,
} from './types';

export function listarAvisosVecino(
  opts: { tipo?: TipoAviso } = {},
): Promise<AvisoRead[]> {
  const params = new URLSearchParams();
  if (opts.tipo) params.set('tipo', opts.tipo);
  const qs = params.toString();
  return apiFetch<AvisoRead[]>(`/vecino/avisos/${qs ? `?${qs}` : ''}`);
}

export function listAvisosAdmin(opts: {
  tipo?: TipoAviso;
  incluir_no_vigentes?: boolean;
} = {}): Promise<AvisoRead[]> {
  const params = new URLSearchParams();
  if (opts.tipo) params.set('tipo', opts.tipo);
  if (opts.incluir_no_vigentes) params.set('incluir_no_vigentes', 'true');
  const qs = params.toString();
  return apiFetch<AvisoRead[]>(`/avisos/${qs ? `?${qs}` : ''}`);
}

export function crearAviso(data: AvisoCreate): Promise<AvisoCreadoResponse> {
  return apiFetch<AvisoCreadoResponse>('/avisos/', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export function retirarAviso(
  avisoId: string,
  vigenteHasta: string,
): Promise<AvisoRead> {
  return apiFetch<AvisoRead>(`/avisos/${avisoId}`, {
    method: 'PATCH',
    body: JSON.stringify({ vigente_hasta: vigenteHasta }),
  });
}
